import { computed } from "vue";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

export const TABLE_COLUMN_WIDTHS = {
  DEFAULT: 380,
  ACTIONS: 60,
  ADD_PROPERTY: 80,
  CHECKBOX: 48,
};

export const excludedHeaders = ["tags", "status", "sequence_status"];

export const linkIcons = computed(
  () => (key, row, source) =>
    [
      {
        condition:
          (row.linkedin_url || row.linkedin) &&
          key === "name" &&
          ["company", "contact", "lead", "recommended_prompts"].includes(
            source,
          ),
        src: imageNames.PROSPECTING_LINKEDIN_GREY,
        url: row.linkedin_url || row.linkedin,
        alt: "linkedin",
      },
      {
        condition: row.company_linkedin && key === "current_company",
        src: imageNames.PROSPECTING_LINKEDIN_GREY,
        url: row.company_linkedin,
        alt: "linkedin",
      },
      {
        condition: row.website && key === "name" && source === "company",
        src: imageNames.PROSPECTING_BROWSER_GREY,
        url: row.website,
        alt: "website",
      },
      {
        condition:
          (row.website || row.company_website) && key === "current_company",
        src: imageNames.PROSPECTING_BROWSER_GREY,
        url: row.website || row.company_website,
        alt: "website",
      },
    ].filter((icon) => icon.condition),
);

export const entityBulkActionsMap = {
  [entityTypes.CONTACT]: [
    "enrich_email",
    "enrich_phone_number",
    "run_market_research",
    "export",
    "delete",
  ],
  [entityTypes.LEAD]: [
    "enrich_email",
    "enrich_phone_number",
    "run_market_research",
    "export",
    "delete",
  ],
  [entityTypes.COMPANY]: [
    "enrich_company",
    "run_market_research",
    "export",
    "delete",
  ],
  [entityTypes.SEQUENCE_ENTITY]: ["remove_from_sequence"],
  default: [],
};

export const BULK_ACTION_DEFINITIONS = [
  {
    id: "edit",
    text: "Edit",
    icon: imageNames.EDIT,
  },
  {
    id: "delete",
    text: "Delete",
    icon: imageNames.DELETE_GREY,
  },
  {
    id: "export",
    text: "Export",
    icon: imageNames.EXPORT_GREY,
  },
  {
    id: "enrich_email",
    text: "Enrich Email",
    icon: imageNames.AGI_PURPLE,
  },
  {
    id: "enrich_phone_number",
    text: "Enrich Phone Number",
    icon: imageNames.AGI_PURPLE,
  },
  {
    id: "enrich_company",
    text: "Enrich Company",
    icon: imageNames.AGI_PURPLE,
  },
  {
    id: "run_market_research",
    text: "Run Market Research",
    icon: imageNames.AGI_PURPLE,
  },
  {
    id: "remove_from_sequence",
    text: "Remove from Sequences",
    icon: imageNames.DELETE_GREY,
  },
];

export const getBulkActionsByEntityType = (entityType) => {
  if (!entityType || !entityBulkActionsMap[entityType]) {
    return [];
  }
  const allowedActionIds = entityBulkActionsMap[entityType];
  return BULK_ACTION_DEFINITIONS.filter((def) =>
    allowedActionIds.includes(def.id),
  );
};

export const createBulkActionOptions = (actionIds, actionHandlers) => {
  return BULK_ACTION_DEFINITIONS.filter((def) =>
    actionIds.includes(def.id),
  ).map((def) => ({
    ...def,
    action: actionHandlers[def.id] || null,
  }));
};
